export default function trackerMenuController() {
    return {
        discoveredCount: 0,
        totalCount: 0,
        isComplete: false,
        viewportHeight: window.innerHeight,

        init() {
						const self = this

            // Get the total count from the data attribute
            this.totalCount = parseInt(this.$el.dataset.totalCount || 0);

            // Initialize discovered count from tracker controller
            this.$watch('$store.tracker.discoveredItems.size', (value) => {
							this.discoveredCount = value;
							this.isComplete = this.discoveredCount === this.totalCount;
            });

						// Check for completion
						setTimeout(() => {
							self.isComplete = self.$store.completion.isComplete;
						}, 100);

            // Watch for changes in selectedItem to update store
            this.$watch('$store.trackerMenu.selectedItem', (value) => {
							this.$store.trackerMenu.activeDetailPanel = value;
            });

            // Watch for changes in store's activeDetailPanel
            this.$watch('$store.trackerMenu.activeDetailPanel', (value) => {
							if (value !== null) {
								// If menu is closed, open it first
								if (this.$store.trackerMenu.phase === 1) {
									this.menuOpen();
								}
								// Set the selected item after a short delay to allow menu to open
								setTimeout(() => {
									this.$store.trackerMenu.selectedItem = value.toString();
								}, this.$store.trackerMenu.phase === 1 ? 600 : 0); // Longer delay if menu was closed
							}
            });

            // Listen for resize and orientation changes
            window.addEventListener('resize', () => this.viewportHeight = window.innerHeight);
            window.addEventListener('orientationchange', () => {
							setTimeout(() => {
								this.viewportHeight = window.innerHeight;
							}, 100);
            });

						// Detect clicks outside the .tracker-menu and close the menu
						document.addEventListener('click', (event) => {
							const trackerMenu = document.querySelector('.tracker-menu');
							if (trackerMenu && !trackerMenu.contains(event.target)) {
								this.menuClose();
							}
						});
        },

				get menuHeight() {
					const headerHeight = window.innerWidth < 768 ? document.querySelector('.logos')?.offsetHeight : 0;
					const bottomMenuHeight = document.querySelector('.bottom-right-menu')?.offsetHeight || 0;
					const calculatedHeight = this.viewportHeight - headerHeight - bottomMenuHeight - 50;

					return `${Math.min(calculatedHeight, window.innerWidth < 768 ? 688 : 815)}px`;
				},

				get menuHeightWithoutPx() {
					const headerHeight = window.innerWidth < 768 ? document.querySelector('.logos')?.offsetHeight : 0;
					const bottomMenuHeight = document.querySelector('.bottom-right-menu')?.offsetHeight || 0;
					const calculatedHeight = this.viewportHeight - headerHeight - bottomMenuHeight - 50;

					return Math.min(calculatedHeight, window.innerWidth < 768 ? 688 : 815);
				},

				get menuHeightInner() {
					const trackerMenuHeight = document.querySelector('.tracker-menu__header')?.offsetHeight || 0;

					return `${this.menuHeightWithoutPx - trackerMenuHeight}px`;
				},

				get menuHeightSubInner() {
					const trackerMenuHeight = document.querySelector('.tracker-menu__header')?.offsetHeight || 0;
					const subMenuHeight = this.$el.parentNode.querySelector('.tracker-menu__detail-panel__close')?.offsetHeight || 0;

					return `${this.menuHeightWithoutPx - trackerMenuHeight - subMenuHeight}px`;
				},

        menuOpen() {
            if (this.$store.trackerMenu.phase === 1) {
                this.$store.trackerMenu.phase = 2;
                this.$store.trackerMenu.isOpen = true;
                setTimeout(() => {
                    this.$store.trackerMenu.phase = 3;
                }, 300);
            } else if (this.$store.trackerMenu.phase === 3) {
                this.menuClose();
            }
        },

        menuClose() {
            this.$store.trackerMenu.phase = 1;
            this.$store.trackerMenu.selectedItem = null;
            this.$store.trackerMenu.isOpen = false;
            this.$store.trackerMenu.activeDetailPanel = null;
        }
    };
}
